 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"core-js-js":"core-js-js","default~app-modules-patient-patient-module~app-modules-sidebar-sidebar-module~components-patient-acc~eafe5b1d":"default~app-modules-patient-patient-module~app-modules-sidebar-sidebar-module~components-patient-acc~eafe5b1d","default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-patient-patient-module~modules~b62a8fdf":"default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-patient-patient-module~modules~b62a8fdf","default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-sidebar-sidebar-module":"default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-sidebar-sidebar-module","default~modules-hbc-go-hbc-go-module~modules-patient-patient-module~modules-sidebar-sidebar-module":"default~modules-hbc-go-hbc-go-module~modules-patient-patient-module~modules-sidebar-sidebar-module","default~app-modules-sidebar-sidebar-module~modules-sidebar-sidebar-module":"default~app-modules-sidebar-sidebar-module~modules-sidebar-sidebar-module","default~modules-admin-admin-module~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-pro~d438e70b":"default~modules-admin-admin-module~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-pro~d438e70b","default~modules-admin-admin-module~modules-hbc-go-hbc-go-module":"default~modules-admin-admin-module~modules-hbc-go-hbc-go-module","modules-admin-admin-module":"modules-admin-admin-module","default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-provider-provider-module":"default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-provider-provider-module","default~modules-hbc-go-hbc-go-module~modules-home-home-module":"default~modules-hbc-go-hbc-go-module~modules-home-home-module","modules-home-home-module":"modules-home-home-module","default~app-modules-hbc-go-components-add-patient-dialog-add-patient-dialog-component~modules-hbc-go~0a5c5ba5":"default~app-modules-hbc-go-components-add-patient-dialog-add-patient-dialog-component~modules-hbc-go~0a5c5ba5","modules-hbc-go-hbc-go-module":"modules-hbc-go-hbc-go-module","dom-js":"dom-js","firebase-auth":"firebase-auth","modules-auth-auth-module":"modules-auth-auth-module","modules-error-error-module":"modules-error-error-module","shadow-css-d7d058ec-d59cb009-js":"shadow-css-d7d058ec-d59cb009-js","stencil-polyfills-css-shim":"stencil-polyfills-css-shim","stencil-polyfills-dom":"stencil-polyfills-dom","components-nora-consult-nora-consult-module":"components-nora-consult-nora-consult-module","components-patient-account-patient-account-module":"components-patient-account-patient-account-module","components-patient-allergies-patient-allergies-module":"components-patient-allergies-patient-allergies-module","components-patient-conditions-patient-conditions-module":"components-patient-conditions-patient-conditions-module","components-patient-timeline-patient-timeline-module":"components-patient-timeline-patient-timeline-module"}[chunkId]||chunkId) + "-es2015." + {"0":"164365b0bb203b8b6c58","1":"32afd6cc80b52c55a51b","2":"08d58a60281e4a25f4a0","3":"018e6106a38b69a214c6","4":"0af4c4128c690419e315","core-js-js":"e071e2a9c1b95284f3e3","default~app-modules-patient-patient-module~app-modules-sidebar-sidebar-module~components-patient-acc~eafe5b1d":"05216d1b7ec59f9c0e05","default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-patient-patient-module~modules~b62a8fdf":"62e75601909ad0d5eb59","default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-sidebar-sidebar-module":"9b192d1501667838793d","default~modules-hbc-go-hbc-go-module~modules-patient-patient-module~modules-sidebar-sidebar-module":"46fc5ccefb333566c3f2","default~app-modules-sidebar-sidebar-module~modules-sidebar-sidebar-module":"ecc790ed4e5210320bf4","default~modules-admin-admin-module~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-pro~d438e70b":"7d6576929018d4b73438","default~modules-admin-admin-module~modules-hbc-go-hbc-go-module":"d52c77df2ab7410a827a","modules-admin-admin-module":"0876c213f5a79f3413eb","default~modules-hbc-go-hbc-go-module~modules-home-home-module~modules-provider-provider-module":"40f4767ea12c39ab330e","default~modules-hbc-go-hbc-go-module~modules-home-home-module":"5fb063f2566b61288360","modules-home-home-module":"ba0ff9dabc1bcbafec8b","default~app-modules-hbc-go-components-add-patient-dialog-add-patient-dialog-component~modules-hbc-go~0a5c5ba5":"be6d9c29c3c511e4f7f8","modules-hbc-go-hbc-go-module":"7ce79d72cd07062fca8b","dom-js":"a66db2152424ff510033","firebase-auth":"edfaa1886084df4cf02e","modules-auth-auth-module":"42e42eaad6c1d373f57e","modules-error-error-module":"de06539e633e45851960","shadow-css-d7d058ec-d59cb009-js":"451e2740a6ab057a233a","stencil-polyfills-css-shim":"9576e831e54289440ca5","stencil-polyfills-dom":"7d2fb0925e1d260d4c72","components-nora-consult-nora-consult-module":"f215b8dcffbbc05318e4","components-patient-account-patient-account-module":"ac869b9e08cf657bde2e","components-patient-allergies-patient-allergies-module":"f4ee04e937c25665e1c8","components-patient-conditions-patient-conditions-module":"a79e5b585e794e6541aa","components-patient-timeline-patient-timeline-module":"37fe49245f1750939209"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
